<template lang='pug'>
//- Upgrade-Page
div(:class='$style[`cc-upgrade-container`]')
  div(:class='$style[`cc-upgrade-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 該
        span.font-doctor-theme 升級
        span.font-normal-theme 瀏覽器
        span.no-wrap 了

      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 推薦使用下列瀏覽器

  div(:class='$style[`cc-upgrade-content`]')
    ul(:class='$style[`cc-upgrade-content-browser`]')
      li(:class='$style[`cc-upgrade-content-browser-list`]')
        a(href='//www.google.com/intl/zh-TW/chrome/' rel='noreferrer' title='前往下載 Chrome')
          IconChrome(:size='60')
          span.font-medium(:class='$style[`cc-upgrade-content-browser-title`]')!= 'Chrome'
          span(:class='$style[`cc-upgrade-content-browser-sub-title`]')!= '前往下載'

      li(:class='$style[`cc-upgrade-content-browser-list`]')
        a(href='//www.mozilla.org/zh-TW/firefox/new/' rel='noreferrer' title='前往下載 Firefox')
          IconFirefox(:size='60')
          span.font-medium(:class='$style[`cc-upgrade-content-browser-title`]')!= 'Firefox'
          span(:class='$style[`cc-upgrade-content-browser-sub-title`]')!= '前往下載'

      li(:class='$style[`cc-upgrade-content-browser-list`]')
        a(href='//www.microsoft.com/zh-tw/edge' rel='noreferrer' title='前往下載 Edge')
          IconEdge(:size='60')
          span.font-medium(:class='$style[`cc-upgrade-content-browser-title`]')!= 'Edge'
          span(:class='$style[`cc-upgrade-content-browser-sub-title`]')!= '前往下載'

</template>

<script>
import IconChrome from '../../icon/Chrome';
import IconFirefox from '../../icon/Firefox';
import IconEdge from '../../icon/Edge';

export default {
  metaInfo() {
    return {
      title: '瀏覽器版本過舊',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/upgrade',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/upgrade',
      }],
    };
  },

  components: {
    IconChrome,
    IconFirefox,
    IconEdge,
  },

  // data () {
  //   return {
  //   }
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/info/upgrade.scss';
</style>
